/** Normaliza YYYY-MM-DD desde ISO u otros formatos. */
export function normalizarFechaContrato(fecha) {
  if (!fecha) return null;
  const texto = String(fecha).split('T')[0];
  return /^\d{4}-\d{2}-\d{2}$/.test(texto) ? texto : null;
}

/**
 * Calcula fecha fin como el backend: inicio + meses - 1 día.
 * Sin plazo → null (vigencia abierta).
 */
export function calcularFechaFinContrato(fechaInicio, plazoMeses) {
  const inicio = normalizarFechaContrato(fechaInicio);
  const meses = Number(plazoMeses);
  if (!inicio || !meses || meses < 1) return null;

  const [y, m, d] = inicio.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  date.setUTCMonth(date.getUTCMonth() + meses);
  date.setUTCDate(date.getUTCDate() - 1);

  const yy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

function fechaFinEfectiva(fechaInicio, plazoMeses, fechaFinExplicit) {
  const fin = normalizarFechaContrato(fechaFinExplicit) || calcularFechaFinContrato(fechaInicio, plazoMeses);
  return fin || '9999-12-31';
}

/** Intervalos inclusive [inicio, fin]. */
export function intervalosSeSolapan(inicioA, finA, inicioB, finB) {
  const a0 = normalizarFechaContrato(inicioA);
  const b0 = normalizarFechaContrato(inicioB);
  if (!a0 || !b0) return false;

  const a1 = normalizarFechaContrato(finA) || '9999-12-31';
  const b1 = normalizarFechaContrato(finB) || '9999-12-31';

  return a0 <= b1 && b0 <= a1;
}

/**
 * Contratos existentes que se cruzan con el rango nuevo.
 * @param {object} rangoNuevo { fecha_inicio, plazo_meses?, fecha_fin? }
 * @param {array} contratos
 * @param {number|null} excluirId
 */
export function buscarContratosSolapados(rangoNuevo, contratos = [], excluirId = null) {
  const inicioNuevo = normalizarFechaContrato(rangoNuevo?.fecha_inicio);
  if (!inicioNuevo) return [];

  const finNuevo = fechaFinEfectiva(
    inicioNuevo,
    rangoNuevo?.plazo_meses,
    rangoNuevo?.fecha_fin
  );

  return (contratos || []).filter((contrato) => {
    if (excluirId != null && Number(contrato.id) === Number(excluirId)) return false;
    const inicio = normalizarFechaContrato(contrato.fecha_inicio);
    if (!inicio) return false;
    const fin = fechaFinEfectiva(inicio, contrato.plazo_meses, contrato.fecha_fin);
    return intervalosSeSolapan(inicioNuevo, finNuevo, inicio, fin);
  });
}

/**
 * Pares de contratos que se solapan entre sí.
 * @returns {{ pares: Array, idsEnSolape: Set<number> }}
 */
export function detectarParesSolapados(contratos = []) {
  const lista = [...(contratos || [])];
  const pares = [];
  const idsEnSolape = new Set();

  for (let i = 0; i < lista.length; i += 1) {
    const a = lista[i];
    const aInicio = normalizarFechaContrato(a.fecha_inicio);
    const aFin = fechaFinEfectiva(aInicio, a.plazo_meses, a.fecha_fin);

    for (let j = i + 1; j < lista.length; j += 1) {
      const b = lista[j];
      const bInicio = normalizarFechaContrato(b.fecha_inicio);
      const bFin = fechaFinEfectiva(bInicio, b.plazo_meses, b.fecha_fin);

      if (!intervalosSeSolapan(aInicio, aFin, bInicio, bFin)) continue;

      idsEnSolape.add(Number(a.id));
      idsEnSolape.add(Number(b.id));
      pares.push({
        contrato_a: {
          id: a.id,
          titulo: a.titulo,
          fecha_inicio: aInicio,
          fecha_fin: aFin === '9999-12-31' ? null : aFin,
        },
        contrato_b: {
          id: b.id,
          titulo: b.titulo,
          fecha_inicio: bInicio,
          fecha_fin: bFin === '9999-12-31' ? null : bFin,
        },
      });
    }
  }

  return { pares, idsEnSolape };
}

export function mensajeConfirmacionSolape(solapados) {
  const nombres = (solapados || [])
    .map((c) => c.titulo || `Contrato #${c.id}`)
    .filter(Boolean);
  const lista = nombres.length ? `\n\n• ${nombres.join('\n• ')}` : '';
  return (
    `Atención: este contrato se solapa en fechas con otro(s) del mismo empleado.${lista}\n\n` +
    '¿Deseas continuar de todos modos?'
  );
}
